import * as React from "react";
// Shared components
import Modal from "components/Modal";
import Button from "components/Button";
// UI Frameworks
import { Row, Col, Spin, Form, Input, Select, Typography, Tooltip } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Hooks and utils
import { shebaFormat } from "helpers/index";
import BankAccountService from "services/http/endpoints/bank-accounts";

const { Option } = Select;
const { Title } = Typography;

interface IProps extends FormComponentProps {
	shouldVisible: boolean;
	onClose: () => void;
	onFinish: () => void;
}

const CreateAccount: React.FC<IProps> = props => {
	const [loading, setLoading] = React.useState(false);
	const { getFieldDecorator, getFieldValue, resetFields } = props.form;

	function formatNumber(value: any) {
		value += "";
		const list = value.split(".");
		const prefix = list[0].charAt(0) === "-" ? "-" : "";
		let num = prefix ? list[0].slice(1) : list[0];
		let result = "";
		while (num.length > 4) {
			result = `-${num.slice(-4)}${result}`;
			num = num.slice(0, num.length - 4);
		}
		if (num) {
			result = num + result;
		}
		return `${prefix}${result}${list[1] ? `.${list[1]}` : ""}`;
	}

	function handleSubmit(e: React.FormEvent): void {
		e.preventDefault();

		props.form.validateFields(async (err, values) => {
			if (!err) {
				try {
					setLoading(true);
					await BankAccountService.addBankAccount(values);
					setLoading(false);
					props.onFinish();
				} catch (error) {
					setLoading(false);
				}
			}
		});
	}

	const value = getFieldValue("value");
	const isCard = getFieldValue("type") === "CARD";
	const label = isCard ? "کارت" : "شبا";
	const title = value ? (
		<span className="ltr">{isCard ? formatNumber(value) : `IR ${shebaFormat(value)}`}</span>
	) : (
		`شماره ${label} خود را به دقت وارد کنید`
	);

	return (
		<Modal
			visible={props.shouldVisible}
			closable={false}
			footer={null}
			onCancel={props.onClose}
			onOk={props.onClose}
		>
			<Spin tip="در حال بارگزاری ..." spinning={loading} size="large">
				<Form onSubmit={handleSubmit}>
					<Row>
						<Title level={4}>شماره {label} جدید</Title>
						<Col span={24}>
							<Form.Item label="نوع حساب">
								{getFieldDecorator("type", {
									initialValue: "CARD",
									rules: [
										{
											required: true,
											message: "لطفا نوع حساب را انتخاب کنید",
										},
									],
								})(
									<Select placeholder="انتخاب" onChange={() => resetFields(["value"])}>
										<Option value="CARD">کارت</Option>
										<Option value="SHABA">شبا</Option>
									</Select>,
								)}
							</Form.Item>
							<Form.Item label="عنوان">
								{getFieldDecorator("name", {
									rules: [
										{
											required: true,
											transform: (value: any) => (value ? value.trim() : value),
											message: "لطفا عنوان حساب را وارد نمایید",
										},
									],
								})(<Input type="text" />)}
							</Form.Item>
							<Form.Item label={`شماره ${label}`}>
								<Tooltip
									title={title}
									trigger="focus"
									placement="topLeft"
									overlayClassName="numeric-input"
								>
									{getFieldDecorator("value", {
										rules: [
											{
												len: isCard ? 16 : 24,
												pattern: isCard ? /\d{16}/g : /\d{24}/g,
												message: `لطفا شماره ${label} خود را صحیح وارد نمایید`,
											},
											{
												required: true,
												message: `لطفا شماره ${label} را وارد نمایید`,
											},
										],
									})(
										<Input
											dir="ltr"
											type="tel"
											className="ltr"
											maxLength={isCard ? 16 : 24}
											prefix={isCard ? null : "IR"}
										/>,
									)}
								</Tooltip>
							</Form.Item>
							<Form.Item className="button-center">
								<Button htmlType="submit" primary loading={loading}>
									ثبت
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Spin>
		</Modal>
	);
};

export default Form.create<IProps>()(React.memo(CreateAccount));
